var allItems = [];
var selectedItems = [];
var selectedItemSlots = [null, null, null, null, null];
var baseUrl = ""

const allItemVanillaTemplate = (item) => `
  <div class="product-card-row ${item.selected ? "visibility-hidden" : ""}">
    <div class="box-sale-product-card">
      <div class="box-sale-product-image-div">
          <a href="${item.onlineStoreUrl}" target="__blank"> <img class="box-sale-product-bg-image" src="${item.featuredImage.url}" alt=""> </a>
      </div>
      <div class="box-sale-product-details">
          <div class="box-sale-product-title">
              ${item.title}
          </div>
          <div class="product-card-fixed-bottom-container">
            <div class="box-sale-product-price">
                &#8377;&nbsp;${item.variants[0].price.amount}
            </div>
            <button
                class="box-sale-add-button custom-offer-button custom-offer-add ${
                  item.selected ? "visibility-hidden" : ""
                }"
                data-variant-id="${item.variants[0].id}">ADD TO BOX</button>
            <button
                class="box-sale-add-button custom-offer-button custom-offer-remove ${
                  !item.selected ? "visibility-hidden" : ""
                }"
                data-variant-id="${item.variants[0].id}">REMOVE FROM BOX</button>
          </div>
      </div>
    </div>
  </div>
`;

const selectedItemVanillaTemplate = (item, index) => `
  <div class="selected-box-item">
    <div class="selected-product ${!item ? "active-empty" : ""} ${item ? "selected-product-background" : ""}">
        ${
          item ? `<img class="box-sale-product-bg-image" src="${item.featuredImage.url}" alt="">` : ``
        }
        ${
          !item
            ? `
            <div>
                ADD
            </div>
            <div>
                Item ${index + 1}
            </div>`
            : ``
        }
        <div>
            <button class="custom-offer-button custom-offer-remove close-x ${
              !item ? "visibility-hidden" : ""
            }" data-variant-id="${item ? item.variants[0].id : ""}"></button>
        </div>
    </div>
    ${item ? `<div class="selected-product-title">${item.title}</div>` : ``}
  </div>
  ${index < 4 ? `<div class="dash-product "></div>` : ``}
`;

const bottomActionsVanillaTemplate = (items, selectedItemVanillaTemplate) => `
  <div class="selected-items selected-items-bottom" id="selected-items-bottom"></div>
  <div class="bottom-actions-nudge ${items.length >= 2 ? "congrats-banner" : ""}" style="${items.length >= 2 ? "background: #177D5D; color: white;" : ""}">
    ${items.length < 2 ? `Add ${2 - items.length} ${items.length >= 1 ? "more" : ""} product${items.length < 2 ? "s" : ""} to unlock this offer` : "Congrats!! You’ve unlocked this offer.  "}
  </div>
  <div class="bottom-actions-container" style="${items.length < 3 ? "justify-content:center;gap:0px" : "justify-content: center;gap:50px"}">
        <span class="bottom-actions-container-total"> ${items.length === 3 ? `Total&nbsp;-&nbsp;&#8377;&nbsp;999/-` : ""}
          ${items.length === 4 ? `Total&nbsp;-&nbsp;&#8377;&nbsp;1199/-` : ""}
          ${items.length === 5 ? `Total&nbsp;-&nbsp;&#8377;&nbsp;1499/-` : ""}
        </span>
    <button id="bottom-actions-container-checkout" ${items.length < 3 ? "disabled" : ""}> GO TO CART </button>
  </div>
`;


function renderVanilla(allItems, selectedItems) {
  selectedItemSlots.forEach((it, index) => {
    selectedItemSlots[index] = selectedItems[index]
      ? selectedItems[index]
      : null;
  });
  //$("#selected-items").html(selectedItemSlots.map(selectedItemVanillaTemplate).join(""));

  $("#all-items").html(allItems.map(allItemVanillaTemplate).join(""));

  $("#bottom-actions").html(bottomActionsVanillaTemplate(selectedItems));

  $("#selected-items-bottom").html(selectedItemSlots.map(selectedItemVanillaTemplate).join(""));
}

function delegateEventHandler(event) {
  if (
    event.target.tagName === "BUTTON" &&
    event.target.classList.contains("custom-offer-add")
  ) {
    if (selectedItems.length >= 5) {
      return;
    }
    let addedItem = allItems.find(
      (it) => it.variants[0].id === event.target.dataset.variantId
    );
    selectedItems.push(addedItem);
    localStorage.setItem("selectedItemsv5.0", JSON.stringify(selectedItems));
    addedItem["selected"] = true;
    renderVanilla(allItems, selectedItems);
    // if(selectedItems.length === 3){
    //   confetti({
    //     particleCount: 100,
    //     spread: 70,
    //     origin: { y: 0.6 },
    //   });
    // }
  } else if (
    event.target.tagName === "BUTTON" &&
    event.target.classList.contains("custom-offer-remove")
  ) {
    let removedItem = allItems.find(
      (it) => it.variants[0].id === event.target.dataset.variantId
    );
    let removedItemInSelectedItemsIndex = selectedItems.findIndex(
      (it) => it.variants[0].id === event.target.dataset.variantId
    );
    selectedItems.splice(removedItemInSelectedItemsIndex, 1);
    localStorage.setItem("selectedItemsv5.0", JSON.stringify(selectedItems));
    removedItem["selected"] = false;
    renderVanilla(allItems, selectedItems);
  } else if (
    event.target.tagName === "BUTTON" &&
    event.target.id === "bottom-actions-container-checkout"
  ) {
    redirectToCheckout();
  }  else if (
    event.target.closest("div.hs-item-close > span > svg")
  ) {
    let currentVariant = event.target.dataset.id || event.target.parentElement.dataset.id || event.target.parentElement.parentElement.dataset.id || event.target.parentElement.parentElement.parentElement.dataset.id;
    currentVariant = "gid://shopify/ProductVariant/" + currentVariant;
    let removedItem = allItems.find(
      (it) => it.variants[0].id === currentVariant
    );
    let removedItemInSelectedItemsIndex = selectedItems.findIndex(
      (it) => it.variants[0].id === currentVariant
    );
    selectedItems.splice(removedItemInSelectedItemsIndex, 1);
    localStorage.setItem("selectedItemsv5.0", JSON.stringify(selectedItems));
    removedItem["selected"] = false;
    renderVanilla(allItems, selectedItems);
  }
}

function withoutEdgesAndNodes(data) {
  let result = Array.isArray(data) ? [] : {};

  if (typeof data !== "object") return data;

  for (const key in data) {
    if (typeof key === "string" && key === "edges") {
      result = withoutEdgesAndNodes(data.edges.map((edge) => edge.node));
    } else {
      result = Object.assign(result, {
        [key]: withoutEdgesAndNodes(data[key]),
      });
    }
  }

  return result;
}


function redirectToCheckout() {
      document.dispatchEvent(new CustomEvent('theme:cart:add',{ detail: { drawer: true, variants: selectedItems.map(it => ({quantity: 1, id: it.variants[0].id.split('/').pop()})) } }));
  }

function loadInitData() {
  let settings = {
    url: baseUrl + "/api/2023-01/graphql.json",
    method: "POST",
    timeout: 0,
    headers: {
      "X-Shopify-Storefront-Access-Token": "56cc7443a7c36761c78387a8a52b61e7",
      "Content-Type": "application/json",
    },
    data: JSON.stringify({
      query: "query {\n  products(first: 100, query: \"tag:'make_your_own_combo'\") {\n    edges {\n      node {\n        id\n       onlineStoreUrl\n        title\n        featuredImage {\n            url\n            altText\n        } \n        metafield(namespace: \"custom\", key: \"box_sale_product_png\") {\n            key\n            value\n        }\n        variants(first: 1) {\n            edges {\n                node {\n                    id\n                    price {\n                        amount\n                    }\n                }\n            }\n        }\n      }\n    }\n  }\n}",
      variables: {},
    }),
  };

  $.ajax(settings).done(function (response) {
    let data = withoutEdgesAndNodes(response.data);
    selectedItems = localStorage.getItem("selectedItemsv5.0")
      ? JSON.parse(localStorage.getItem("selectedItemsv5.0"))
      : [];

    let selectedItemIds = selectedItems.map((it) => it.id);
    allItems = selectedItems.length
      ? data.products.map((it) => {
          selectedItemIds.includes(it.id)
            ? (it["selected"] = true)
            : (it["selected"] = false);
          return it;
        })
      : data.products;
    renderVanilla(allItems, selectedItems);
  });
}

window.addEventListener("DOMContentLoaded", (event) => {

  document.addEventListener('click',function(event){
    try{
      delegateEventHandler(event);
    }
    catch(e) {
      console.log(e);
    }
 });
  document.querySelector(".selected-products-list").style.top = document.querySelector('#shopify-section-header').clientHeight + "px";
  loadInitData();
});
